import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { General } from "../tools/styles";
import { theme } from "../theme";
import FloatButton from "../components/ui/FloatButton";
import FloatCard from "../components/ui/FloatCard";
import Generic from "../components/Generic";
import styled from "styled-components";
import calcSedComplete from '../tools/calcSedComplete'
import { soilTypes } from '../tools/soilInfo'
import {WatchContext} from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import BackToDash from "../components/BackToDash";
// import calcComplete from "../tools/calcComplete";

const Styles = {
  SmSelect: styled(General.Select)`
  max-width: 15rem;
  `,
}

const Soil = () => {
  
  let {soil, setSoil} = useContext(WatchContext);

  const handleChange = ({ target }) => {

    let data = handleInputChange(soil, target)

    let conversion =
      data.depth > 129.54
        ? '>51"'
        : data.depth <= 129.54 && data.depth > 40.64
          ? '16-51"'
          : data.depth <= 40.64 && data.depth > 20.32
            ? '8-16"'
            : data.depth <= 20.32
              ? '<8"'
              : 0;
    data = { ...data, conversion }

    let organicGrade =
      data.depth > 129.54
        ? "A"
        : data.depth <= 129.54 && data.depth > 40.64
          ? "A"
          : data.depth <= 40.64 && data.depth > 20.32
            ? "B"
            : data.depth <= 20.32
              ? "C"
              : "";
    data = { ...data, organicGrade }

    let parentGrade =
      data.parentType === "sand, loamy-sand"
        ? "A"
        : data.parentType === "silty-loam, loam"
          ? "B"
          : data.parentType === "silt-clay, clay"
            ? "C"
            : "";
    data = { ...data, parentGrade }

    let decompGrade =
      data.decompLevel === "L1: H1-H4, Fibric, Peat, Oi"
        ? "A"
        : data.decompLevel === "L2: H5-H7, Hemic, Mucky Peat, Oe"
          ? "B"
          : data.decompLevel === "L3: H8-H10, Sapric, Muck, Oa"
            ? "C"
            : "";
    data = { ...data, decompGrade }

    let finalGrade = (organicGrade === 'A' && parentGrade === 'A' && decompGrade === 'A') ? 'A' : (organicGrade === 'C' ? 'C' : 'B' && parentGrade === 'C' ? 'C' : 'B' && decompGrade === 'C') ? 'C' : 'B'
    data = { ...data, finalGrade }

    // console.log(parentGrade, 'parent')
    let soilSuggestion = soilTypes.filter(
      (soil) => soil.grade === parentGrade && soil.depth === conversion
    )[0]?.type || "no suggested soil type";
    // console.log(soilSuggestion, 'soilSuggestions')
    
    data = { ...data, soilSuggestion}

    let completeData = calcSedComplete(data)

    setSoil(completeData);
  };

  return (
    <General.Background backgroundColor={`${theme.colors.pdeOrange + 40}`}>
      <General.Heading color={theme.colors.pdeOrange}>
        {soil.title}
      </General.Heading>
      <BackToDash/>
      <Generic text={soil.metric} title="Metric" />
      <Generic text={soil.method} title="Method" />
      {/* organic thickness */}
      <General.BlockContainer>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              <span>Measurement Method</span>
              <General.Input
                style={{ width: '12rem' }}
                type="text"
                name="organicMethod"
                value={soil.organicMethod}
                onChange={handleChange}
                placeholder="Enter text"
              />
            </General.InputCont>
            <General.InputCont>
              <span>Depth (cm)</span>
              <General.Input
                type="number"
                name="depth"
                value={soil.depth}
                onChange={handleChange}
                placeholder="Enter a number"
              />
            </General.InputCont>
            <General.InputCont>
              <span>Conversion to Inches: {soil.conversion}</span>
            </General.InputCont>
            <General.InputCont>
              <span>Grade: {soil.organicGrade}</span>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <h2>Organic Thickness</h2>
        </General.Block>
      </General.BlockContainer>
      {/* parent material */}
      <General.BlockContainer>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              <span>Type</span>
              <Styles.SmSelect
                name="parentType"
                onChange={handleChange}
                value={soil.parentType}
              >
                <option value="">-- Please choose an option</option>
                {[
                  "sand, loamy-sand",
                  "silty-loam, loam",
                  "silt-clay, clay",
                ].map((type, i) => (
                  <option key={i} value={type}>
                    {type}
                  </option>
                ))}
              </Styles.SmSelect>
            </General.InputCont>
            <General.InputCont>
              <span>Depth Collected</span>
              <Styles.SmSelect
                name="parentDepth"
                onChange={handleChange}
                value={soil.parentDepth}
              >
                <option value="">-- Please choose an option</option>
                {['<8"', '8-16"', '16-51"', '>51"'].map((level, i) => (
                  <option key={i} value={level}>
                    {level}
                  </option>
                ))}
              </Styles.SmSelect>
            </General.InputCont>
            <General.InputCont>
              <span>Measurement Method</span>
              <General.Input
                style={{ width: '12rem' }}
                type="text"
                name="parentMethod"
                value={soil.parentMethod}
                onChange={handleChange}
                placeholder="Enter text"
              />
            </General.InputCont>
            <General.InputCont>
              <span>Grade: {soil.parentGrade}</span>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <h2>Parent Material</h2>
        </General.Block>
      </General.BlockContainer>
      {/* decomp state */}
      <General.BlockContainer>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              <span>Level</span>
              <Styles.SmSelect
                name="decompLevel"
                onChange={handleChange}
                value={soil.decompLevel}
              >
                <option value="">-- Please choose an option</option>
                {[
                  "L1: H1-H4, Fibric, Peat, Oi",
                  "L2: H5-H7, Hemic, Mucky Peat, Oe",
                  "L3: H8-H10, Sapric, Muck, Oa",
                ].map((level, i) => (
                  <option key={i} value={level}>
                    {level}
                  </option>
                ))}
              </Styles.SmSelect>
            </General.InputCont>
            <General.InputCont>
              <span>Depth Collected</span>
              <General.Input
              style={{width: '15rem'}}
                type="number"
                name="decompDepth"
                value={soil.decompDepth}
                onChange={handleChange}
                placeholder="Enter number"
              />
            </General.InputCont>
            <General.InputCont>
              <span>Measurement Method</span>
              <General.Input
                style={{ width: '12rem' }}
                type="text"
                name="decompMethod"
                value={soil.decompMethod}
                onChange={handleChange}
                placeholder="Enter text"
              />
            </General.InputCont>
            <General.InputCont>
              <span>Grade: {soil.decompGrade}</span>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <h2>Decomposition State</h2>
        </General.Block>
      </General.BlockContainer>
      <General.BlockContainer>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              <span>{soil.soilSuggestion}</span>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <h2>Suggested Soil Type</h2>
        </General.Block>
      </General.BlockContainer>
      <General.BlockContainer>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              <span>{soil.finalGrade}</span>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <h2>Final Grade</h2>
        </General.Block>
      </General.BlockContainer>
      <BackToDash/>
    </General.Background>
  );
};

export default Soil;
